import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { PurchaseOrderReceiptEntity } from './purchase-order-receipt.entity';

/**
 * Link table between PurchaseOrderReceipt and File. Mirrors
 * `purchase_order__file` from the RFQ work. Used for receipt-level
 * documents — packing slip photos, dock arrival photos, BOL scans.
 * Per-exception damage photos are linked separately via
 * `purchase_order_receipt_exception__file`.
 */
@Index('po_receipt__file__fk__file__id_fk', ['fkFileId'], {})
@Index(
	'po_receipt__file__fk_purchase_order_receipt__id_fk',
	['fkReceiptId'],
	{},
)
@Entity('purchase_order_receipt__file')
export class PurchaseOrderReceiptFileEntity extends BaseEntity {
	@Column('int', { name: 'fk_purchase_order_receipt__id', unsigned: true })
	public fkReceiptId!: number;

	@Column('int', { name: 'fk__file__id', unsigned: true })
	public fkFileId!: number;

	/** Optional human-readable label ("Packing slip", "Crushed pallet front view"). */
	@Column('varchar', { name: 'caption', length: 255, nullable: true })
	public caption!: string | null;

	@ManyToOne(() => PurchaseOrderReceiptEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: 'fk_purchase_order_receipt__id', referencedColumnName: 'id' },
	])
	public fkReceipt!: PurchaseOrderReceiptEntity;

	@ManyToOne(() => FileEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
